import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authentication';
import billingReducer from './billing';
import commonReducer from './common';
import deviceReducer from './device';
import paymentsReducer from './payments';
import usersReducer from './users';
import customerReducer from './customer';

const rootReducer = combineReducers({
  authentication: authReducer,
  billing: billingReducer,
  common: commonReducer,
  device: deviceReducer,
  payments: paymentsReducer,
  users: usersReducer,
  customers: customerReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
